import { render } from "./LoginView.vue?vue&type=template&id=ca840748&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=ca840748&scoped=true&lang=css"

import exportComponent from "D:\\env\\git\\sb34work-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca840748"]])

export default __exports__